/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const typography = {
  button: {
    height: '2.75rem',
    textTransform: 'none',
    fontSize: '1rem',
  },
  avatar: {
    maxWidth: '1.5rem',
    maxHeight: '1.5rem',
    fontSize: '0.9rem',
  },
};
